import React, { FC, HTMLAttributes, useRef, useState } from 'react'
import { Button, Col, Divider, Input, Row, Select, Spin } from 'antd'
import { SelectProps } from 'rc-select'
import useClickOutside from '../../hooks/useClickOutside'
import Icon from '../Icon'
import RSaveOverlayContainer from './styles'

interface Props extends HTMLAttributes<HTMLDivElement> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  displayDelete?: boolean
  displayOverlayTriggerButton?: boolean
  loadDataOptions?: SelectProps['options']
  onLoadData?: SelectProps['onChange']
  onDelete?: () => void
  onSave?: (dataName: string) => void
}

const RSaveOverlay: FC<Props> = ({
  children,
  displayDelete = false,
  displayOverlayTriggerButton = true,
  loadDataOptions = [],
  onSave,
  onDelete,
  onLoadData,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)
  const [saveName, setSaveName] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useClickOutside(ref, () => {
    setVisible(false)
  })

  async function saveData() {
    setIsLoading(true)
    try {
      if (onSave) {
        await onSave(saveName)
      }
      setSaveName('')
      setVisible(false)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <RSaveOverlayContainer ref={ref} {...props}>
      {displayOverlayTriggerButton && (
        <Button
          className='save-overlay-toggle'
          icon={<Icon icon='bars' margin={false} />}
          onClick={() => setVisible(true)}
        />
      )}

      <div className={`save-overlay-container ${visible ? '' : 'hidden'}`}>
        <Spin spinning={isLoading}>
          <div className='save-overlay-container-inner'>
            <h3>Load Data</h3>
            <Select className='w-100' options={loadDataOptions} onChange={onLoadData} value='' />

            <Divider />

            <Row gutter={20} align='middle'>
              <Col>
                <Input
                  placeholder='Name'
                  onChange={(e) => setSaveName(e.target.value)}
                  value={saveName}
                />
              </Col>

              <Col>
                <Button type='primary' disabled={!saveName} onClick={saveData}>
                  Save
                </Button>
              </Col>
            </Row>
          </div>
        </Spin>
      </div>

      <div className='save-overlay-content'>{children}</div>

      {displayDelete && (
        <Button
          className='save-overlay-delete-button'
          icon={<Icon icon='trash-alt' margin={false} />}
          danger
          onClick={onDelete}
        />
      )}
    </RSaveOverlayContainer>
  )
}

export default RSaveOverlay
